<template>
    <DsModal
        :is-open="isOpen"
        show-back
        size="med"
        :title="$t('funnel.edit.send.http.request.copy.campaign.modal.title')"
        @close="closeCopyFromCampaignList"
        @back="closeCopyFromCampaignList"
    >
        <template #header>
            <DsFilledButton
                data-qa="done-button"
                :disabled="!enableDoneButton"
                @click="doneCopyFromCampaign"
            >
                {{ $t('funnel.edit.done') }}
            </DsFilledButton>
        </template>
        <template #default>
            <DsMultiselect
                v-model="campaignListSelected"
                label-prop="value"
                value-prop="id"
                required
                class="selected-campaign-type"
                :readonly="isLoading"
                :loading="isLoading"
                :options="campaignList"
                :placeholder="$t('funnel.edit.send.http.request.copy.campaign.modal.select.placeholder')"
                @input="selectCampaign"
            />

            <DsMultiselect
                v-show="selectCampaignModeEnabled"
                v-model="httpRequestCopyCampaignSelected"
                label-prop="label"
                value-prop="key"
                class="selected-http-request-url-funnel"
                :options="funnelList"
                :placeholder="$t('funnel.edit.send.http.request.copy.campaign.modal.copy.placeholder')"
                @input="selectHttpPost"
            />
            <div class="process-tip">
                <div class="process-tip-icon">
                    <DsIcon name="info-circle" />
                </div>
                <div class="process-tip-text">
                    {{ $t('funnel.edit.send.http.request.copy.campaign.modal.tip.overview') }}
                </div>
            </div>
        </template>
    </DsModal>
</template>

<script>
import {
    getFilteredHttpRequestCampaigns,
    getHttpRequestFunnel,
} from '../sendHttpRequest/send.http.request.api';

export default {
    name: 'HttpRequestCopyFromCampaign',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
    },
    emits: ['http-request-copy-from-campaign', 'close-copy-from-campaign-list'],

    data() {
        return {
            isLoading: false,
            campaignList: [],
            funnelList: [],
            selectCampaignModeEnabled: false,
            enableDoneButton: false,
            campaignListSelected: null,
            httpRequestCopyCampaignSelected: null,
        };
    },

    mounted() {
        this.loadCampaigns();
    },

    methods: {
        async selectHttpPost() {
            this.enableDoneButton = true;
        },
        async selectCampaign({ id }) {
            try {
                this.httpRequestCopyCampaignSelected = null;
                const payload = {
                    value: id,
                };
                const funnels = await getHttpRequestFunnel(payload);

                this.selectCampaignModeEnabled = true;

                this.funnelList = Object.entries(funnels.options).map(([key, label]) => ({
                    key, label,
                }));
            } catch (error) {
                const errorMessage = this.$t('funnel.edit.send.http.request.copy.campaign.failed.message');

                this.$error({
                    message: errorMessage,
                });
            }
        },
        async loadCampaigns() {
            try {
                this.isLoading = true;
                const dataCampaigns = await getFilteredHttpRequestCampaigns();

                this.campaignList = Object.entries(dataCampaigns.funnelMap).map(([id, value]) => ({
                    id, value,
                }));
            } catch (error) {
                const errorMessage = this.$t('funnel.edit.send.http.request.copy.load.campaign.failed.message');

                this.$error({
                    message: errorMessage,
                });
            } finally {
                this.isLoading = false;
            }
        },
        closeCopyFromCampaignList() {
            this.$emit('close-copy-from-campaign-list');
        },
        doneCopyFromCampaign() {
            const { key } = this.httpRequestCopyCampaignSelected;

            this.$emit('http-request-copy-from-campaign', key);
            this.closeCopyFromCampaignList();
        },
    },
};
</script>

<style lang="scss" scoped>
.process-tip {
    display:            flex;
    padding:            px-to-rem(12);
    border-radius:      px-to-rem(8);
    flex-wrap:          wrap;
    justify-items:      left;
    background-color:   $color-aqua-050;
}

.process-tip-icon {
    flex:   6%;
    color:  $color-aqua;
}

.process-tip-text {
    margin-top: $spacing-025;
    flex:   94%;
    color:  $color-ink-900;
}
</style>
